import React from 'react';
import styled from 'styled-components';

interface Student {
  _id: string;
  firstName: string;
  lastName: string;
  grade: string;
  email: string;
}

interface Class {
  _id: string;
  name: string;
  grade: string;
  students: Student[];
}

interface ClassListProps {
  classes: Class[];
  onSelectClass: (classItem: Class) => void;
}

const ClassGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
`;

const ClassCard = styled.div`
  background: white;
  border-radius: 0.5rem;
  padding: 1.5rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
`;

const ClassName = styled.h3`
  margin: 0;
  color: #111827;
  font-size: 1.125rem;
  font-weight: 600;
`;

const ClassInfo = styled.p`
  margin: 0.5rem 0;
  color: #6B7280;
  font-size: 0.875rem;
`;

const StudentCount = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #4B5563;
  font-size: 0.875rem;
  margin-top: 0.5rem;
`;

const ClassList: React.FC<ClassListProps> = ({ classes, onSelectClass }) => {
  return (
    <ClassGrid>
      {classes.map((cls) => (
        <ClassCard key={cls._id} onClick={() => onSelectClass(cls)}>
          <ClassName>{cls.name}</ClassName>
          <ClassInfo>Grade: {cls.grade}</ClassInfo>
          <StudentCount>
            <span>👥</span>
            <span>{cls.students.length} Students</span>
          </StudentCount>
        </ClassCard>
      ))}
    </ClassGrid>
  );
};

export default ClassList; 